import Dialog from '~/domains/design-system/components/Dialog/Dialog';
import dt from '~/testing';

import ExistingAccountContent from './ExistingAccountContent';

const dtIds = dt.components.shared.auth.signUpVersionTwo.existingAccountModal;

type ExistingAccountModalProps = {
  email: string;
  isOpen: boolean;
  onLogIn: () => void;
  onUseDifferentEmail: () => void;
};

export default function ExistingAccountModal({
  email,
  isOpen,
  onLogIn,
  onUseDifferentEmail,
}: ExistingAccountModalProps) {
  return (
    <Dialog
      type={{ desktop: 'modal', mobile: 'drawer' }}
      isOpen={isOpen}
      dataTestId={dtIds.modal}
    >
      <ExistingAccountContent
        email={email}
        onLogIn={onLogIn}
        onUseDifferentEmail={onUseDifferentEmail}
      />
    </Dialog>
  );
}
